import React, { Component } from "react";
import { Button, Row, Col, Alert, InputGroup } from "reactstrap";

import { RepForm } from "./RepForm";
import { LoadingModal } from "./LoadingModal";
import { FetchData } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

import AddIcon from "../images/add.png";
import { RepTableDefault } from "./RepTableDefault";

export class Rep extends Component {
  static displayName = Rep.name;

  constructor(props) {
    super(props);
    this.state = {
      repList: [],
      loading: false,
      fetchingData: false,
      modal: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      model: {
        EventType: "insert",
        RepId: null,
        ClientId: null,
        RepLastName: "",
        RepFirstName: "",
        RepPhone: "",
        RepPhone2: "",
        RepNote: "",
        RepZip: "",
        RepState: "",
        RepEmail: "",
        RepBillingEmail: "",
        RepInactiveFlg: false,
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: "",
        ClientAbbrv: "",
        ClientPhone: "",
        ClientPhone2: "",
        ClientEmail: "",
      },
      searchModel: {
        RepName: "",
        RepPhone: "",
        Client: "",
        ClientAbbrv: "",
        Inactive: false,
        SortBy: "repLastName",
        SortDirection: "asc",
      },
    };
    this.user = JSON.parse(GetCookie("user"));

    this.setModal = this.setModal.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.resetFields = this.resetFields.bind(this);

    this.renderRepTable = this.renderRepTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    //
    this.setFetchingData = this.setFetchingData.bind(this);
    this.populateRepData = this.populateRepData.bind(this);
  }

  componentDidMount() {
    //this.populateRepData();
  }

  setModal() {
    this.setState({ modal: !this.state.modal });
  }

  resetFields() {
    this.setState((prevState) => ({
      model: {
        EventType: "insert",
        RepId: null,
        ClientId: null,
        RepLastName: "",
        RepFirstName: "",
        RepPhone: "",
        RepPhone2: "",
        RepNote: "",
        RepZip: "",
        RepState: "",
        RepEmail: "",
        RepBillingEmail: "",
        RepInactiveFlg: false,
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: "",
        ClientAbbrv: "",
        ClientPhone: "",
        ClientPhone2: "",
      },
    }));

    this.setModal();
  }

  handleDoubleClick(repData) {
    this.setState((prevState) => ({
      model: {
        EventType: "update",
        ClientId: repData.data.clientId,
        RepId: repData.data.repId,
        ClientId: repData.data.clientId,
        RepLastName: repData.data.repLastName,
        RepFirstName: repData.data.repFirstName,
        RepPhone: repData.data.repPhone,
        RepPhone2: repData.data.repPhone2,
        RepNote: repData.data.repNote,
        RepZip: repData.data.repZip,
        RepState: repData.data.repState,
        RepEmail: repData.data.repEmail,
        RepBillingEmail: repData.data.repBillingEmail,
        RepInactiveFlg: repData.data.repInactiveFlg,
        CreateDateTime: repData.data.createDateTime,
        CreatebyUserId: repData.data.createbyUserId,
        UpdateByUserId: repData.data.updateByUserId,
        UpdateDateTime: repData.data.updateDateTime,
        IsDeletedFlg: repData.data.isDeletedFlg,
        ClientName: repData.data.clientName,
        ClientAbbrv: repData.data.clientAbbrv,
        ClientPhone: repData.data.clientPhone,
        ClientPhone2: repData.data.clientPhone2,
        ClientEmail: repData.data.clientEmail,
      },
    }));
    this.setModal();
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));

        if (alert.model?.EventType === "insert") {
          this.setState(
            {
              searchModel: {
                RepName: alert.model.RepLastName,
                RepPhone: "",
                Client: "",
                ClientAbbrv: "",
                Inactive: false,
                SortBy: "repLastName",
                SortDirection: "asc",
              },
            },
            () => {
              this.populateRepData();
            }
          );
        } else this.populateRepData();
      }
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    if (e.target.name === "Inactive") {
      model[e.target.name] = !this.state.searchModel.Inactive;
    } else {
      model[e.target.name] = e.target.value;
    }

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRepData();
    }
  }

  setFetchingData(fetching) {
    console.log(fetching);
    this.setState({ fetchingData: fetching });
  }

  async populateRepData() {
    this.setState({ fetchingData: true });

    FetchData("/getreps", "POST", this.user.token, this.state.searchModel).then(
      (data) => {
        this.setState({ repList: data, loading: false, fetchingData: false });
      }
    );
  }

  renderRepTable() {
    return (
      <RepTableDefault
        reps={this.state.repList}
        handleDoubleClick={this.handleDoubleClick}
      />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRepTable()
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Rep</h5>
        <Row>
          <Col>
            <InputGroup size="sm">
              <Button color="btn" onClick={this.resetFields} size="sm">
                <img
                  src={AddIcon}
                  style={{ width: "16px", height: "16px" }}
                  alt="Add"
                />{" "}
              </Button>
              <input
                name="RepName"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.RepName}
                onChange={this.handleSearchChange}
                placeholder="RepName (Lastname Firstname)"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="RepPhone"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.RepPhone}
                onChange={this.handleSearchChange}
                placeholder="Phone"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Client"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Client}
                onChange={this.handleSearchChange}
                placeholder="Client"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="ClientAbbrv"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClientAbbrv}
                onChange={this.handleSearchChange}
                placeholder="Client Abbrv"
                onKeyDown={this.handleKeyDown}
              />
              <span className="input-group-text">Inactive:</span>
              <input
                name="Inactive"
                className="input-checkbox"
                type="checkbox"
                defaultChecked={this.state.searchModel.Inactive}
                onChange={this.handleSearchChange}
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <LoadingModal fetchingData={this.state.fetchingData} />

        {this.state.modal && (
          <RepForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            setFetchingData={this.setFetchingData}
          />
        )}

        <div>{contents}</div>
      </div>
    );
  }
}
